// customcombobox.component.ts
import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-customcombobox',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './customcombobox.component.html',
  styleUrl: './customcombobox.component.css'
})
export class CustomcomboboxComponent implements OnInit, OnChanges {
  @Input() items$?: Observable<string[]>;
  @Input() placeholder: string = '';
  @Input() initialValue: string = '';
  @Input() hasError: boolean = false;
  @Output() selectionChange = new EventEmitter<string>();

  inputValue: string = '';
  filteredItems: string[] = [];
  showDropdown: boolean = false;
  private allItems: string[] = [];

  ngOnInit() {
    this.inputValue = this.initialValue;
    if (this.items$) {
      this.items$.subscribe(items => {
        this.allItems = items;
        this.filteredItems = [...items];
        if (this.inputValue && !items.includes(this.inputValue)) {
          this.inputValue = '';
          this.selectionChange.emit('');
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['initialValue']) {
      this.inputValue = changes['initialValue'].currentValue || '';
    }
  }

  filterItems() {
    this.filteredItems = this.allItems.filter(item =>
      item.toLowerCase().includes(this.inputValue.toLowerCase())
    );
  }

  selectItem(item: string) {
    this.inputValue = item;
    this.showDropdown = false;
    this.selectionChange.emit(item);
  }

  addNewItem() {
    if (this.inputValue && !this.allItems.includes(this.inputValue)) {
      this.allItems.push(this.inputValue);
      this.filteredItems = [...this.allItems];
      this.selectItem(this.inputValue);
    } else if (this.inputValue) {
      this.selectItem(this.inputValue);
    }
    this.showDropdown = false;
  }

  onFocus() {
    this.showDropdown = true;
    this.filterItems();
  }

  onBlur() {
    setTimeout(() => {
      this.showDropdown = false;
    }, 200);
  }

  onInputChange(value: string) {
    this.selectionChange.emit(value);
  }

  reset() {
    this.inputValue = '';
    this.filteredItems = [...this.allItems];
    this.showDropdown = false;
    this.selectionChange.emit('');
  }
}